import React from 'react';
import { apiAction } from 'api/api';
import { getSearchURL } from 'api/urls';
import { useHistory } from 'react-router';
import { constants } from 'utils/Constant';
import * as Actions from '../../state/Actions'
import CustomSearch from 'components/search/CustomSearch';
import { addLabelValue } from 'proptypes/ArrayProptype';

const SearchContainer = (props) => {
    const { customStyles, icon, placeHolder } = props
    let dispatch = Actions.getDispatch(React.useContext)
    const history = useHistory()
    const handleInputChange = (value) => {
        if (value) {
            dispatch(Actions.stateChange('loader',true))
            history.push(`${constants.finalyze}/?company__name=` + encodeURIComponent(value.label) + '&company__symbol=' + encodeURIComponent(value.value))
        }
    }

    const loadOptions = (inputValue) =>
        new Promise(async (resolve) => {
            let res = await apiAction({ url: getSearchURL(inputValue) })
            resolve(res ? addLabelValue(res, "name", "symbol") : '')
        })

    return (
        <CustomSearch
            handleInputChange={handleInputChange}
            icon={icon}
            loadOptions={loadOptions}
            customStyles={customStyles}
            placeHolder={placeHolder}
        />
    );
}

export default SearchContainer;

